import { UserApi } from '@/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { User } from '@/types/user';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@/types/http';
import { Customer } from '@/types/auth';
import FileApi from '@/apis/FileApi';

export default class UserStore extends BaseStore {
    users: User[] = [];
    api: UserApi;
    fileApi: FileApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            users: observable,
            getMyInfo: flow.bound
        });
        this.api = new UserApi();
        this.fileApi = new FileApi();
    }

    *getMyInfo() {
        try {
            const res: ResponseData<Customer> = yield this.rootStore.apiStore.call(this.fileApi, this.fileApi.getMyInfo, null, { hideLoading: true });
            if (res.ok) {
                return res.data;
            }
            return undefined;
        } catch (error) {
            return undefined;
        }
    }

    clean(): void {
        super.clean();
        this.users = [];
    }
}
